import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  params: {
    page: 1,
    totalPage: 2,
    limit: 10,
    searchText: '',
    startDate: null,
    endDate: null,
    orderState: [],
    orderType: null,
    reservedDate: null,
    storeNo: null
  },
  pageInfo: {},
  list: [],
  detail: {
    orderNo: 0,
    orderManageNo: '-',
    storeNo: 0,
    userNo: 0,
    name: '-',
    phone: '-',
    address: '-',
    addressDetail: '',
    longitude: '',
    latitude: '',
    orderState: '',
    bank: '',
    accountNumber: '',
    depositHolder: '',
    orderType: '-',
    orderDate: '-',
    reservedDate: null,
    inquiry: '-',
    paymentMethod: '',

    orderIncomeTime: '',
    orderCheckTime: '',
    cookingTime: '',
    deliveryTime: '',
    completedTime: '',
    cancelledTime: '',
    cookingDuration: '',
    deliveryDuration: '',

    cancelReason: '',
    isCustomerCancellation: '',
    memo: '',
    totalProductsPrice: '',
    deliveryFee: '',
    discountAmount: '',
    couponDiscountAmount: '',
    pointUsageAmount: '',
    cancelledAmount: '',
    balance: '',
    isShow: '',
    orderDetails: []
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
